














import { Component, Vue, Watch } from 'vue-property-decorator'
import Axios from 'axios'
import { sentryMessage } from '@/system/sentry'

@Component({
  components: {
    MiniLoader: require('@/components/MiniLoader').default
  }
})
export default class PaymentPending extends Vue {
  paymentStatusMessage: string = ''

  async fetchSubscription() {
    this.$store.commit('subscription/reset')
    await this.$store.dispatch('subscription/fetchStatus')
  }

  async fetchPaymentStatus() {
    const { data: { status } } = await Axios.get('/user/payment-status')

    if (status === 'paid') {
      sentryMessage('payment status paid after timeout, should not happen')

      this.paymentStatusMessage = 'Payment succeeded. Please refresh the page if you are not getting redirected.'
    } else if (status === 'expired') this.paymentStatusMessage = 'Payment expired. Please try again.'
    else if (status === 'failed') this.paymentStatusMessage = 'Payment failed. Please try again. Rekordcloud is located in the Netherlands and you may need to instruct your credit card provider to allow foreign payments.'
    else if (status === 'canceled') this.paymentStatusMessage = 'Payment canceled. Please try again.'
  }

  async created() {
    setTimeout(async () => {
      if (!(this as any)._isDestroyed) {
        await this.fetchSubscription()

        if (!this.$store.state.subscription.active) { // Still not active, something has probably gone wrong
          setTimeout(async () => {
            await this.fetchPaymentStatus()
          }, 5000)
        }
      }
    }, 10000)
  }

  @Watch('$store.state.subscription.active', { immediate: true })
  async watchActive(active: boolean) {
    if (active) {
      await this.$router.push({
        name: 'subscription success'
      })
    }
  }
}
